// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__21p4_","title":"Images45_title__1eOl8","images":"Images45_images__1Ndqy"};